import { call, put } from "redux-saga/effects";
import { getAuditLogsFailure, getAuditLogsSuccess } from "../../../Slices/auditLogSlice";
import { getAuditLogs } from "../../../../Services/apiService";

export function* auditLogHandler(action) {
    try {
        const response = yield call(getAuditLogs, { params: action.payload });
        yield put(getAuditLogsSuccess(response));
    } catch (err) {
        yield put(getAuditLogsFailure(err?.response?.data || "Failed to fetch audit logs."));
    }
}